import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { TranslateModule } from '@ngx-translate/core';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { FailedComponent } from './components/failed/failed.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { LoggedInAsPopupComponent } from './components/logged-in-as-popup/logged-in-as-popup.component';
import { LogoutButtonComponent } from './components/login-status-logout/logout-button.component';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { MenuListComponent } from './components/menu-list/menu-list.component';
import { MaterialModule } from '../modules/material.module';
import { HashtagModule } from '../hashtag/hashtag.module';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { GlobalSearchResultComponent } from './components/global-search-result/global-search-result.component';
import { TenantIdListComponent } from './components/tenant-id-list/tenant-id-list.component';
import { MenuListRecursiveComponent } from './components/menu-list-recursive/menu-list-recursive.component';
import { DepartmentDropdownComponent } from './components/department-dropdown/department-dropdown.component';
import { AdminInnerNavComponent } from './components/admin-inner-nav/admin-inner-nav.component';
import { UIElementsModule } from '../shared/ui-elements/ui-elements.module';
import { AppLoaderDirective } from '../shared/directives/app-loader.directive';
import { MenuTreeModule } from '../shared/menu-tree-module/menu-tree.module';
import { ContainsPipe } from './pipes/contains.pipe';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { DepartmentSelectorMobileComponent } from './components/department-selector-mobile/department-selector-mobile.component';
import { UserProfileDropdownMobileComponent } from './components/user-profile-dropdown-mobile/user-profile-dropdown-mobile.component';
import { TextControlModule } from '../shared/text-control-module/text-control.module';
import { ResizeDirective } from '../shared/directives/resize.directive';
import { AppendDomainPipe } from '../shared/pipes/append-domain-name.pipe';

@NgModule({
  declarations: [
    AdminInnerNavComponent,
    DashboardComponent,
    DepartmentDropdownComponent,
    DepartmentSelectorMobileComponent,
    FailedComponent,
    GlobalSearchComponent,
    GlobalSearchResultComponent,
    LanguageSelectorComponent,
    LoggedInAsPopupComponent,
    LogoutButtonComponent,
    MainNavComponent,
    MenuListComponent,
    MenuListRecursiveComponent,
    PieChartComponent,
    TenantIdListComponent,
    UserProfileDropdownMobileComponent,
  ],
  imports: [
    AppendDomainPipe,
    AppLoaderDirective,
    BreadcrumbModule,
    CommonModule,
    ContainsPipe,
    HashtagModule,
    MaterialModule,
    MenuTreeModule,
    TextControlModule,
    ResizeDirective,
    RouterModule,
    TranslateModule,
    UIElementsModule,
  ],
  exports: [
    AppendDomainPipe,
    DashboardComponent,
    FailedComponent,
    LanguageSelectorComponent,
    LoggedInAsPopupComponent,
    LogoutButtonComponent,
    MainNavComponent,
    MenuListComponent,
    TextControlModule,
    MaterialModule,
  ],
})
export class CoreModule {}
